import {ConditionBase} from "./ConditionBase";
import {Condition} from "../AdvancedSearchControls";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import * as React from "react";

export class MultipleItemsCondition extends ConditionBase{
    GetComparisons(): { Label: string; Value: string }[] {
        return [
            {Label:'Contains',Value:'contains'},
            {Label:'Not Contains',Value:'not contains'}
        ];
    }

    GetValueEditor(editor: Condition, callback: () => void): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        let value:any=editor.Value;
        if(!Array.isArray(editor.Value))
            value=[];
        return(
            <SearchableSelect Value={editor.Value} onChange={x=>{editor.Value=(x as any).map(x=>x.value);callback();}} isMulti={true}>
                {this.Options.Options.map(x=>
                    <option key={x.label} value={x.label}>{x.label}</option>
                )}
            </SearchableSelect>
        )
    }

}